import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  WorkspaceRepository,
  WorkspaceRepositoryUID,
} from "@radarly/core/workspace/repositories/WorkspaceRepository";

export function useProjectWorkspaces(projectId: number) {
  const repository = useInjection<WorkspaceRepository>(WorkspaceRepositoryUID);
  const { data, isLoading, isFetching } = useQuery(
    ["/project/workspaces", { projectId }],
    () => {
      return repository.getProjectWorkspaces(projectId);
    }
  );
  return {
    workspaces: data,
    loading: isLoading || isFetching,
  };
}
